import angular from 'angular';
import ngRedux from 'ng-redux';

import reduxConfig from './redux.config';
import { settingsActions } from './settings.reducer';
import { selectedActions } from './selected.reducer';
import { dataActions } from './data.reducer';
import { deploymentFrequencyActions } from './deployment-frequency'
import { timePeriodsActions } from './time-periods';
import { environmentTypesActions } from './environment-types';
import { summaryActions } from './summary';
import { leadTimeActions } from './lead-time';
import { changeVolumeActions } from './change-volume';
import { activityActions } from './activity';


export default angular.module('dbm.dashboard.redux', [ngRedux])
.config(['$ngReduxProvider',reduxConfig])
.service('SettingsActions', ['$http','api','$q',settingsActions])
.service('SelectedActions', ['$http','api',selectedActions])
.service('DataActions', ['$http','colorizer','api','$q',dataActions])
.service('DeploymentFrequencyActions', ['$http','$q','api',deploymentFrequencyActions])
.service('TimePeriodsActions', ['$http','api',timePeriodsActions])
.service('EnvironmentTypesActions', ['$http','api',environmentTypesActions])
.service('SummaryActions', ['$http','api','$q',summaryActions])
.service('LeadTimeActions', ['$http','$q','api',leadTimeActions])
.service('ChangeVolumeActions', ['$http','$q','api',changeVolumeActions])
.service('ActivityActions', ['$http', 'api', '$q',activityActions])
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/redux/index.js